import { useQuery } from "@tanstack/react-query"
import { getAdmins } from "@/lib/api/admin.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetAdmins() {
  const { accessToken } = useAuthStore()

  return useQuery({
    queryKey: ["admins"],
    queryFn: async () => {
      if (!accessToken) throw new Error("Not authenticated")
      const response = await getAdmins(accessToken)
      return response.data
    },
    enabled: !!accessToken,
  })
}
